// extracted by mini-css-extract-plugin
export default {"categoryOption":"NestedCategoryFilters-module__categoryOption___3lHL4"};